module.exports = __webpack_public_path__ + "media/images/site/infantil_mascaras-e8e937d6c3bcb67f11932398af76d01b.jpg";